module.exports = __webpack_public_path__ + "img/icon-support-mail-white.29b88de9.svg";